import { combineReducers } from 'redux';
import ChatListReducer from './ChatList/ChatListReducer';
import AuthReducer from './Auth/AuthReducer';
import UserReducer from './UserDetails/UserReducer';
import LeaderBoardReducer from './LeaderBoard/LeaderBoardReducer';
import ArticleReducer from './Articles/ArticleReducer';
import EventReducer from './Events/EventReducer';
import ProductReducer from './Products/ProductReducer';

export default combineReducers({
    list: ChatListReducer,
    login: AuthReducer,
    userList: UserReducer,
    leaderBoardList: LeaderBoardReducer,
    article: ArticleReducer,
    event: EventReducer,
    product: ProductReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js